export default "__VITE_ASSET__ea3c0ba8__"